import React from 'react'
import CustTable from '../../Common/CustTable'
import { t } from 'i18next'
import { Button, Popover } from 'antd'
import { FormOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs'
import { Color } from '../../Common/Color'
import { displayHierarchy, tagFormat } from '../../Common/Common'
import Pagination from '../../Common/Pagination'

const columns = (showEvent, resolveEvent) => [
  {
    width: 20,
    title: t('Admin.EventList.table.created_since'),
    dataIndex: 'created_at',
    key: 'created_at',
    render: (value) => displayCreationDateInformations(dayjs(value))
  },
  {
    width: 15,
    title: t('Admin.EventList.table.number'),
    dataIndex: 'number',
    key: 'number',
    sorter: (a, b) => a.number.localeCompare(b.number)
  },
  {
    width: 15,
    title: t('Admin.EventList.table.resolved'),
    dataIndex: 'resolved',
    key: 'resolved',
    render: (resolved) => resolved ? <CheckOutlined style={{ color: Color.green }} /> : <CloseOutlined style={{ color: Color.red }} />
  },
  {
    width: 55,
    title: t('Admin.EventList.table.businessArea'),
    dataIndex: 'businessArea',
    key: 'businessArea',
    render: (_, o) => displayHierarchy(o.tags)
  },
  {
    width: 35,
    title: t('Admin.EventList.table.tag'),
    dataIndex: 'tag',
    key: 'tag',
    render: (_, o) => displayTags(o)
  },
  {
    width: 100,
    title: t('Admin.EventList.table.title'),
    dataIndex: 'title',
    key: 'title',
    sorter: (a, b) => a.title.localeCompare(b.title)
  },
  {
    width: 25,
    title: t('Admin.EventList.table.comment_count'),
    dataIndex: 'comments_count',
    key: 'comments_count'
  },
  {
    width: 30,
    title: t('Admin.EventList.table.box'),
    dataIndex: 'box',
    key: 'box',
    sorter: (a, b) => a.box - b.box,
    render: (_, event) => (event.box && <Link to={`/admin/boxes/${event.box.id}/calendar`}>{event.box.name}</Link>)
  },
  {
    width: 20,
    key: 'action',
    render: (_, o) => (<div style={{ display: 'flex', justifyContent: 'space-evenly' }} >
      <Button shape="circle" icon={<FormOutlined />} onClick={() => showEvent(o.id)} />
      <Button shape="circle" icon={o.resolved ? <CloseOutlined /> : <CheckOutlined />} onClick={() => resolveEvent(o)} />
    </div>)
  }
]

const displayCreationDateInformations = (date) => {
  return (
    <Popover content={date.format('DD/MM/YYYY HH:mm')} title={t('Admin.EventList.table.created_at')}>
      <span style={{ width: '100%', display: 'block' }}>
        {`${displayTimeUnit(date, 'day')} ${displayTimeUnit(date, 'hour')} ${displayTimeUnit(date, 'minute')}`}
      </span>
    </Popover>
  )
}

const displayTimeUnit = (date, unit) => {
  let value = dayjs().diff(date, unit)
  if (unit === 'hour') {
    value = value % 24
  } else if (unit === 'minute') {
    value = value % 60
  }
  return value > 0 ? `${value} ${t(`Admin.Time.unit.${unit}`)}` : ''
}

const displayTags = (event) => {
  return event.tags.map((tag) => (<div key={`${event.id}-${tag.id}`}>{tagFormat(tag, 'tag')}</div>))
}

export default function EventListXL ({ events, showEvent, pagination, getEvents, filters, resolveEvent }) {
  const rowClassName = (record) => {
    return record.new ? 'new-event' : ''
  }

  const onChange = (page) => {
    getEvents(filters, page)
  }

  return (
    <>
      {pagination.current_page && <Pagination currentPage={parseInt(pagination.current_page)} maxPage={parseInt(pagination.max_page)} onChange={onChange} />}
      <CustTable
        style={{ height: 'calc(100vh - 290px)' }}
        height={'calc(100vh - 290px)'}
        initColumns={columns(showEvent, resolveEvent)}
        key={'number'}
        className={'events'}
        rowClassName={rowClassName}
        dataSource={events}
      />
    </>
  )
}
